const formatSwissPrice = (value: number) => {
    const fixed = String(value.toFixed(2));
    const parts = fixed.split('.');
    const withApostrophe = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '’');
    return `${withApostrophe}.${parts[1]}`;
};

export default formatSwissPrice;
